import React, { Component } from 'react';
import SubActions from '.';
import SubActionButton from './SubActionButton';
import ModifySimoAutoRenewModal from 'components/modals/ModifySimoAutoRenewModal';
import ExpireSimoSubModal from 'components/modals/ExpireSubModal/simo';
import SimoActivateModal from 'components/modals/ActivateModal/simo';
import SetSimoUpcomingPlanModal from 'components/modals/SetUpcomingPlanModal/simo';
import SetSimoPlanModal from 'components/modals/SetPlanModal/simo';
import UpgradeSimoPlanModal from 'components/modals/UpgradePlanModal/simo';
import SimoImmediateRenewalModal from 'components/modals/ImmediateRenewalModal/simo';
import { can, permActions } from 'permissions';

const {
  SET_SIMO_PLAN,
  SET_SIMO_UPCOMING_PLAN,
  UPGRADE_SIMO_INVOICE,
  ACTIVATE_SIMO_SUB,
  CHANGE_SIMO_AUTO_RENEW,
  EXPIRE_SIMO_SUB,
  SET_SIMO_IMMEDIATE_RENEWAL,
} = permActions;

class SimoSubActions extends Component {
  state = {
    opennedModal: '',
  };

  setOpennedModal = (modal) => this.setState({ opennedModal: modal });
  closeModal = () => this.setState({ opennedModal: '' });

  render() {
    const { sub, user, loggedInUser } = this.props;
    const { opennedModal } = this.state;

    const isExpired = sub?.simo_status === 'expired';
    const isNew = sub?.simo_status === 'new';
    const isAcknowledge = sub?.simo_status === 'acknowledged';
    const isActive = sub?.simo_status === 'active';

    const showSetPlan = !isExpired && can(loggedInUser, SET_SIMO_PLAN);
    const showSetUpcomingPlan =
      !isExpired && can(loggedInUser, SET_SIMO_UPCOMING_PLAN);
    const showUpgradeInvoice =
      isActive && can(loggedInUser, UPGRADE_SIMO_INVOICE);
    const showActivate = isAcknowledge && can(loggedInUser, ACTIVATE_SIMO_SUB);
    const showModifyAutoRenew =
      !isExpired && !isNew && can(loggedInUser, CHANGE_SIMO_AUTO_RENEW);
    const showExpire =
      !isExpired && !isNew && can(loggedInUser, EXPIRE_SIMO_SUB);
    const showImmediateRenewal =
      isActive &&
      sub.cycle_type === 'activation' &&
      can(loggedInUser, SET_SIMO_IMMEDIATE_RENEWAL);

    const buttons = [
      {
        id: SET_SIMO_PLAN,
        iconPath: '',
        text: 'Set Plan',
        onClick: this.setOpennedModal,
        isShown: showSetPlan,
      },
      {
        id: SET_SIMO_UPCOMING_PLAN,
        iconPath: '',
        text: 'Set Upcoming Plan',
        onClick: this.setOpennedModal,
        isShown: showSetUpcomingPlan,
      },
      {
        id: UPGRADE_SIMO_INVOICE,
        iconPath: '',
        text: 'Plan Upgrade',
        onClick: this.setOpennedModal,
        isShown: showUpgradeInvoice,
      },
      {
        id: ACTIVATE_SIMO_SUB,
        iconPath: '/images/icons/subActions/user-icon.svg',
        text: 'Activate Sub',
        onClick: this.setOpennedModal,
        isShown: showActivate,
      },
      {
        id: CHANGE_SIMO_AUTO_RENEW,
        iconPath: '/images/icons/subActions/settings-icon.svg',
        text: 'Modify Auto Renew',
        onClick: this.setOpennedModal,
        isShown: showModifyAutoRenew,
      },
      {
        id: SET_SIMO_IMMEDIATE_RENEWAL,
        iconPath: '',
        text: 'Scheduled Renewal',
        onClick: this.setOpennedModal,
        isShown: showImmediateRenewal,
      },
      {
        id: EXPIRE_SIMO_SUB,
        iconPath: '/images/icons/subActions/cross-icon.svg',
        text: 'Expire Sub',
        onClick: this.setOpennedModal,
        isShown: showExpire,
      },
    ];

    return (
      <SubActions>
        {buttons.map((button) => (
          <SubActionButton key={button.id} {...button} />
        ))}
        <ModifySimoAutoRenewModal
          sub={sub}
          isOpen={opennedModal === CHANGE_SIMO_AUTO_RENEW}
          closeModal={this.closeModal}
        />
        <ExpireSimoSubModal
          sub={sub}
          isOpen={opennedModal === EXPIRE_SIMO_SUB}
          closeModal={this.closeModal}
        />
        <SimoActivateModal
          sub={sub}
          isOpen={opennedModal === ACTIVATE_SIMO_SUB}
          closeModal={this.closeModal}
        />
        <SetSimoUpcomingPlanModal
          sub={sub}
          subId={sub?.id}
          user={user}
          isOpen={opennedModal === SET_SIMO_UPCOMING_PLAN}
          closeModal={this.closeModal}
        />
        <SetSimoPlanModal
          sub={sub}
          subId={sub?.id}
          user={user}
          isOpen={opennedModal === SET_SIMO_PLAN}
          closeModal={this.closeModal}
        />
        <UpgradeSimoPlanModal
          sub={sub}
          subId={sub?.id}
          user={user}
          isOpen={opennedModal === UPGRADE_SIMO_INVOICE}
          closeModal={this.closeModal}
        />
        <SimoImmediateRenewalModal
          sub={sub}
          subId={sub?.id}
          isOpen={opennedModal === SET_SIMO_IMMEDIATE_RENEWAL}
          closeModal={this.closeModal}
        />
      </SubActions>
    );
  }
}

export default SimoSubActions;
